import React from 'react';
import { CalendarClock, X, Calendar, Check, Loader2 } from 'lucide-react';

const DecisionModal = ({
    isOpen,
    onClose,
    decisionSection,
    decisionDate,
    setDecisionDate,
    isUpdating,
    handleExtensionDecision,
    toDMY
}) => {
    const [notes, setNotes] = React.useState('');

    React.useEffect(() => {
        if (isOpen) {
            setNotes('');
        }
    }, [isOpen, decisionSection]);

    if (!isOpen || !decisionSection) return null;

    return (
        <div className="ai-modal-overlay" style={{ zIndex: 10006 }}>
            <div className="ai-modal-content" style={{ maxWidth: '420px', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' }}>
                <div className="ai-modal-header" style={{ padding: '0.75rem 1.25rem', borderBottom: '1px solid #F1F5F9', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div className="ai-modal-title" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <CalendarClock size={18} color="#EF4444" />
                        <h3 style={{ fontSize: '0.9rem', fontWeight: '700', color: '#0F172A', margin: 0 }}>Review Extension Request</h3>
                    </div>
                    <button className="modal-close-btn" style={{ padding: '4px', background: 'transparent', border: 'none', cursor: 'pointer', color: '#64748B' }} onClick={onClose}>
                        <X size={18} />
                    </button>
                </div>

                <div className="ai-modal-body" style={{ padding: '1.25rem', display: 'flex', flexDirection: 'column', gap: '1rem', background: '#FFFFFF' }}>
                    <div style={{ marginBottom: '0.85rem', paddingBottom: '0.75rem', borderBottom: '1px dashed #E2E8F0' }}>
                        <div style={{ fontSize: '0.62rem', color: '#64748B', fontWeight: '800', textTransform: 'uppercase', marginBottom: '0.2rem', letterSpacing: '0.05em' }}>Requested By</div>
                        <div style={{ fontSize: '0.9rem', fontWeight: '700', color: '#1E293B' }}>
                            {decisionSection.extension_request?.requested_by_name || decisionSection.assigned_user?.name || decisionSection.assigned_to?.[0]?.name || 'Team Member'}
                        </div>
                    </div>

                    <div className="modal-row" style={{ display: 'flex', gap: '1rem', marginBottom: '0.85rem' }}>
                        <div className="modal-field-group" style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                            <label style={{ fontSize: '0.65rem', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em' }}>ORIGINAL DEADLINE</label>
                            <div className="smart-date-wrapper" style={{ background: '#F1F5F9', opacity: 0.8, borderRadius: '8px', border: '1.5px solid #E2E8F0' }}>
                                <div className="modal-input" style={{ color: '#64748B', padding: '0.5rem 0.75rem', fontSize: '0.8rem', fontWeight: '500' }}>
                                    {toDMY(decisionSection.extension_request?.original_deadline_at_request)}
                                </div>
                            </div>
                        </div>
                        <div className="modal-field-group" style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                            <label style={{ fontSize: '0.65rem', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em' }}>APPROVED DEADLINE</label>
                            <div className="smart-date-wrapper" style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0', display: 'flex', alignItems: 'stretch' }}>
                                <input
                                    type="text"
                                    className="modal-input smart-input"
                                    value={decisionDate}
                                    onChange={(e) => setDecisionDate(e.target.value)}
                                    placeholder="DD-MM-YYYY"
                                    style={{ padding: '0.5rem 0.75rem', fontSize: '0.8rem', fontWeight: '500', border: 'none', outline: 'none', flex: 1 }}
                                />
                                <div
                                    className="calendar-trigger-wrapper"
                                    style={{ cursor: 'pointer', width: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderLeft: '1px solid #E2E8F0', background: '#F1F5F9' }}
                                    onClick={(e) => e.currentTarget.querySelector('.hidden-native-picker')?.showPicker()}
                                >
                                    <Calendar size={14} className="calendar-icon-trigger" style={{ color: '#64748B' }} />
                                    <input
                                        type="date"
                                        className="hidden-native-picker"
                                        style={{ position: 'absolute', opacity: 0, width: '100%', height: '100%', cursor: 'pointer' }}
                                        onChange={(e) => setDecisionDate(toDMY(e.target.value))}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-field-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                        <label style={{ fontSize: '0.65rem', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em' }}>EMPLOYEE REASON</label>
                        <div style={{
                            padding: '0.75rem 1rem',
                            background: '#F8F9FA',
                            borderRadius: '8px',
                            fontSize: '0.8rem',
                            color: '#475569',
                            lineHeight: '1.4',
                            border: '1px solid #F1F5F9'
                        }}>
                            "{decisionSection.extension_request?.employee_reason || 'No reason provided.'}"
                        </div>
                    </div>

                    <div className="modal-field-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', marginBottom: '1rem' }}>
                        <label style={{ fontSize: '0.65rem', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em' }}>DECISION NOTES / REASON</label>
                        <textarea
                            className="modal-input"
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                            placeholder="Enter notes or reason for approval/rejection..."
                            rows={2}
                            style={{
                                padding: '0.5rem 0.75rem',
                                fontSize: '0.8rem',
                                fontWeight: '500',
                                borderRadius: '8px',
                                border: '1.5px solid #E2E8F0',
                                outline: 'none',
                                resize: 'none',
                                fontFamily: 'inherit'
                            }}
                        />
                    </div>
                </div>

                <div className="ai-modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', padding: '0.75rem 1.25rem', borderTop: '1px solid #F1F5F9', background: '#F8F9FA' }}>
                    <button
                        className="secondary-action-btn"
                        style={{
                            borderColor: '#FCA5A5',
                            color: '#EF4444',
                            padding: '0.35rem 0.65rem',
                            fontSize: '0.75rem',
                            borderRadius: '5px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            background: '#FFFFFF',
                            cursor: 'pointer',
                            lineHeight: '1.2',
                            height: '28px'
                        }}
                        onClick={async () => {
                            const success = await handleExtensionDecision(decisionSection.id || decisionSection._id, 0, null, notes || "Rejected.");
                            if (success) onClose();
                        }}
                        disabled={isUpdating}
                    >
                        {isUpdating ? <Loader2 size={12} className="animate-spin" /> : <X size={12} />}
                        <span>Reject</span>
                    </button>
                    <button
                        className="primary-action-btn"
                        style={{
                            background: '#10B981',
                            color: '#FFFFFF',
                            border: 'none',
                            boxShadow: '0 3px 8px rgba(16, 185, 129, 0.15)',
                            padding: '0.35rem 0.65rem',
                            fontSize: '0.75rem',
                            borderRadius: '5px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            cursor: 'pointer',
                            lineHeight: '1.2',
                            height: '28px'
                        }}
                        onClick={async () => {
                            const parts = decisionDate.split('-');
                            const isoDate = parts.length === 3 ? `${parts[2]}-${parts[1]}-${parts[0]}` : decisionDate;
                            const success = await handleExtensionDecision(decisionSection.id || decisionSection._id, 1, isoDate, notes || "Approved.");
                            if (success) onClose();
                        }}
                        disabled={isUpdating || !decisionDate}
                    >
                        {isUpdating ? <Loader2 size={12} className="animate-spin" /> : <Check size={12} />}
                        <span>Accept & Update</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DecisionModal;
